jQuery(function() {
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(this).scrollTop();
    let mvHeight = jQuery(".mv").height();
    let navHeight = jQuery(".index-nav").height();
    let Height = mvHeight + navHeight;

    if (Height < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }
  });
});

const initSwiper = () => {
  const mySwiper = new Swiper("#swiper", {
    speed: 3000,
    slidesPerView: 3,
    loopAdditionalSlides: 2,
    allowTouchMove: false, // スワイプ無効
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    }
    /*     freeMode: {
      enabled: true,
      momentum: false
    },
    on: {
      touchEnd: swiper => {
        swiper.slideTo(swiper.activeIndex + 1);
      }
    } */
  });
};

window.addEventListener("load", function() {
  initSwiper(); // ページ読み込み後に初期化
});
